// SynthOS built-in feedback widget — auto-embedded on every build.
// Never remove this or build a replacement feedback system.
export function initFeedbackWidget() {
  const projectId = __FEEDBACK_PROJECT_ID__;
  const widgetUrl = __FEEDBACK_WIDGET_URL__;
  if (!projectId || !widgetUrl) return;
  try {
    const s = document.createElement('script');
    s.async = true;
    s.src = widgetUrl;
    s.setAttribute('data-project-id', projectId);
    document.body.appendChild(s);
  } catch {
    /* no-op */
  }
}
